import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponseBase, HttpResponse } from '@angular/common/http';
import { GetSBImagesQuery } from '../viewmodels/ISearchService';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { mergeMap as _observableMergeMap, catchError as _observableCatch, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class ShoppingBasketService {
  myAppUrl: string = "";

  public BasketCount = 0;

  public BasketCountSub: BehaviorSubject<number> = new BehaviorSubject<number>(this.BasketCount);

  BasketCountSub$: Observable<number> = this.BasketCountSub.asObservable();
  
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  private trigger: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  trigger$ = this.trigger.asObservable();

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  private _renderTrigger: Subject<void> = new Subject<void>();

  get renderTrigger$() {
    return this._renderTrigger.asObservable();
  }

  triggerRender() {
    this._renderTrigger.next();
    console.log("force SB trigger render - service");
  }

  forceRefresh() {
    this.trigger.next(true);
    console.log("force SB refresh from service");
  }

  updateBasketCount(cnt: number) {
    this.BasketCount = cnt;
    this.BasketCountSub.next(cnt);
    console.log('Basket count: ' + cnt.toString());
    this.trigger.next(true);
    console.log("force SB refresh from service");
  }

  getSBAmount(search: GetSBImagesQuery) {
    console.log('service.getSBAmount')
    let url_ = this.myAppUrl + "api/CoreData/GetSBAmount";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };


     return this._http.request("post", url_, options_).pipe(map((res: any) => {
      return new Blob([res.body], {
        type: 'application/zip'
      });
    }));
  }

  getSBAuth(search: GetSBImagesQuery): Observable<any> {
    console.log('service.getSBAuth');

    let url_ = this.myAppUrl + "api/CoreData/GetSBAuth";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: 'json',
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this._http.request("post", url_, options_);

  }

  saveSBCharge(search: GetSBImagesQuery): Observable<any> {
    console.log('service.SBcharge');

    let url_ = this.myAppUrl + "api/CoreData/saveSBCharge";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: 'json',
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this._http.request("post", url_, options_);

  }

  logServiceError(msg: string): boolean {

    let url = this.myAppUrl + 'api/CoreData/LogServiceError?msg=' + msg;
    //console.log('auth user - ' + url);
    this._http.get<boolean>(url).subscribe(
      (data => { console.log(data); })
    );

    return true;
  }

  printSBImages(search: GetSBImagesQuery): Observable<any> {
    console.log('service.printSB');
    this.logServiceError('printSBImages in SB svc ' + search.authCode);

    let url_ = this.myAppUrl + "api/CoreData/printSBImages";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: 'json',
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };

    return this._http.request("post", url_, options_);

  }


  getSBImages(search: GetSBImagesQuery): Observable<any> {
    console.log('getSBImgs in SB.service client')
    let url_ = this.myAppUrl + "api/CoreData/GetSBImages";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "timeout": '600000',
      })
    };

    console.log(options_);

    return this._http.request("post", url_, options_).pipe(map((res: any) => {
      return new Blob([res.body], {
        type: 'application/zip'
      });
    }));
  }


  getUnindexedType(indexId: string): string {

    let ret = '';

    switch (indexId) {
      case '1':
        ret = 'Writ 1911-1966';
        break;
      case '2':
        ret = 'Attach 1967-2006';
        break;
      case '3':
        ret = 'Old Age Asst Liens Index 1942-1950';
        break;
      //case '4':
      //  ret = 'Old Age Asst Liens Index 1949-1988';
      //  break;
      case '4':
        ret = 'Old Age Asst Liens';
        break;
      case '5':
        ret = 'Grantor 1840-1860';
        break;
      case '6':
        ret = 'Grantee 1840-1860';
        break;
      case '7':
        ret = 'Grantor 1861-1885';
        break;
      case '8':
        ret = 'Grantee 1861-1885';
        break;
      case '9':
        ret = 'Grantor 1886-1909';
        break;
      case '10':
        ret = 'Grantee 1886-1909';
        break;
      case '11':
        ret = 'Grantor 1909-1926';
        break;
      case '12':
        ret = 'Grantee 1909-1926';
        break;
      case '13':
        ret = 'Grantor 1926-1938';
        break;
      case '14':
        ret = 'Grantee 1926-1938';
        break;
      case '15':
        ret = 'Grantor 1938-1947';
        break;
      case '16':
        ret = 'Grantee 1938-1947';
        break;
      case '17':
        ret = 'Grantor 1948-1951';
        break;
      case '18':
        ret = 'Grantee 1948-1951';
        break;
      case '19':
        ret = 'Grantor 1952-1961';
        break;
      case '20':
        ret = 'Grantee 1952-1961';
        break;
    }

    return ret;
  }

//  getCCAuth(ccnum: string, ccfname: string, cclname: string, ccmonth: string, ccyear: string, ccv: string, cczip: string, ccamount: number): Observable<any> {

//    console.log('service.getCCAuth');

//    //test
//    let url_ = 'https://testapi.paygov.us/PaymentProcessingService.asmx'
//    let pwd = 'T9r6gFzd'

//    ////prod
//    //let url_ = 'https://ws3.paygov.us/PaymentProcessingService.asmx'
//    //let pwd = '5snSTR2V'

//    let content_ = '<?xml version="1.0" encoding="UTF-8"?>'
//    content_ += '<soap:Envelope xmlns:soap="http://www.w3.org/2003/05/soap-envelope" xmlns:pay="http://PayGov.us/">'
//    content_ += '    <soap:Header/>'
//    content_ += '        <soap:Body>'
//    content_ += '            <pay:ProcessCCPaymentByLocationCode>'
//    content_ += '            <pay:apiUserId>aitllc</pay:apiUserId>'
//    content_ += '            <pay:apiPassword>' + pwd + '</pay:apiPassword>'
//    content_ += '            <pay:locationCodeId>37128</pay:locationCodeId>'
//    content_ += '            <pay:firstName>' + ccfname + '</pay:firstName>'
//    content_ += '            <pay:lastName>' + cclname + '</pay:lastName>'
//    content_ += '            <pay:address1></pay:address1>'
//    content_ += '            <pay:address2></pay:address2>'
//    content_ += '            <pay:city></pay:city>'
//    content_ += '            <pay:state></pay:state>'
//    content_ += '            <pay:zip>' + cczip + '</pay:zip>'
//    content_ += '            <pay:phone></pay:phone>'
//    content_ += '            <pay:email></pay:email>'
//    content_ += '            <pay:mobilePhone></pay:mobilePhone>'
//    content_ += '            <pay:paymentAmount>' + ccamount + '</pay:paymentAmount>'
//    content_ += '            <pay:cardNumber>' + ccnum + '</pay:cardNumber>'
//    content_ += '            <pay:expirationMonth>' + ccmonth + '</pay:expirationMonth>'
//    content_ += '            <pay:expirationYear>' + ccyear + '</pay:expirationYear>'
//    content_ += '            <pay:cvv2>' + ccv + '</pay:cvv2>'
//    content_ += '            <pay:track1/>'
//    content_ += '            <pay:lstUserData>'
//    content_ += '            <pay:UserData>'
//    content_ += '                <pay:Id>0</pay:Id>'
//    content_ += '                <pay:UserValue></pay:UserValue>'
//    content_ += '            </pay:UserData>'
//    content_ += '            </pay:lstUserData>'
//    content_ += '            <pay:userId>00000000-0000-0000-0000-000000000000</pay:userId>'
//    content_ += '            <pay:invoiceId/>'
//    content_ += '            <pay:handlingFee>0</pay:handlingFee>'
//    content_ += '            </pay:ProcessCCPaymentByLocationCode>'
//    content_ += '        </soap:Body>'
//    content_ += '</soap:Envelope>';


//    let options_: any = {
//      body: content_,
//      headers: new HttpHeaders({
//        'Content-Type': 'text/xml',
//        'Accept': 'text/xml'
//      }),
//      responseType: 'text'
//    };

////    console.log(content_);
////    console.log(options_);

//    return this._http.request("post", url_, options_);

//  }

}
